var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootcampjsduration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_1651)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_158_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.375 15.7082C25.375 20.2391 25.375 22.5046 24.2211 24.0927C23.8485 24.6056 23.3974 25.0567 22.8845 25.4293C21.2964 26.5832 19.0309 26.5832 14.5 26.5832C9.96907 26.5832 7.70361 26.5832 6.11546 25.4293C5.60256 25.0567 5.1515 24.6056 4.77885 24.0927C3.625 22.5046 3.625 20.2391 3.625 15.7082V13.2915C3.625 12.2778 3.625 11.3775 3.63792 10.5728L3.72266 10.5728C4.75218 10.5728 5.37929 10.5729 5.92023 10.4872C8.89319 10.0163 11.2248 7.68469 11.6957 4.71173C11.7814 4.17079 11.7813 3.54368 11.7813 2.51416L11.7813 2.42943C12.586 2.4165 13.4863 2.4165 14.5 2.4165C19.0309 2.4165 21.2964 2.4165 22.8845 3.57036C23.3974 3.943 23.8485 4.39406 24.2211 4.90697C25.375 6.49511 25.375 8.76058 25.375 13.2915V15.7082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63669 8.69703C5.26405 8.75605 4.80394 8.76009 3.70395 8.76025C3.81802 7.0207 4.09693 5.84555 4.77885 4.90697C5.1515 4.39406 5.60256 3.943 6.11546 3.57036C7.05405 2.88844 8.2292 2.60953 9.96874 2.49545C9.96859 3.59545 9.96454 4.05555 9.90552 4.42819C9.55749 6.6256 7.8341 8.34899 5.63669 8.69703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63794 10.0728L3.14589 10.0727L3.13799 10.5647C3.125 11.3734 3.125 12.2771 3.125 13.2885V13.2915V15.7082V15.7393C3.125 17.9784 3.12499 19.6997 3.27214 21.0578C3.42098 22.4316 3.72517 23.4931 4.37435 24.3866C4.77783 24.9419 5.26622 25.4303 5.82157 25.8338C6.71509 26.483 7.77654 26.7872 9.15033 26.936C10.5085 27.0832 12.2297 27.0832 14.4689 27.0832H14.5H14.5311C16.7703 27.0832 18.4915 27.0832 19.8497 26.936C21.2235 26.7872 22.2849 26.483 23.1784 25.8338C23.7338 25.4303 24.2222 24.9419 24.6257 24.3866C25.2748 23.4931 25.579 22.4316 25.7279 21.0578C25.875 19.6997 25.875 17.9784 25.875 15.7393V15.7082V13.2915V13.2604C25.875 11.0212 25.875 9.29998 25.7279 7.94184C25.579 6.56804 25.2748 5.50659 24.6257 4.61307C24.2222 4.05772 23.7338 3.56934 23.1784 3.16585L22.8873 3.56658L23.1784 3.16585C22.2849 2.51668 21.2235 2.21249 19.8497 2.06364C18.4915 1.9165 16.7703 1.9165 14.5311 1.9165H14.5H14.497C13.4856 1.9165 12.5819 1.9165 11.7732 1.92949L11.2812 1.93739L11.2813 2.42945L11.2813 2.51418V2.5142C11.2813 3.55964 11.2799 4.14055 11.2019 4.63351C10.7649 7.39253 8.60103 9.55638 5.84201 9.99337C5.34904 10.0714 4.76814 10.0728 3.7227 10.0728H3.72267L3.63794 10.0728ZM5.71491 9.19087L5.63669 8.69703L5.71491 9.19087C8.12626 8.80895 10.0174 6.91776 10.3994 4.50641L9.90552 4.42819L10.3994 4.50641C10.4661 4.08529 10.4686 3.57708 10.4687 2.49552L10.4688 1.96158L9.93602 1.99652C8.16872 2.11242 6.87677 2.3992 5.82157 3.16585C5.26622 3.56934 4.77783 4.05772 4.37435 4.61307C3.6077 5.66827 3.32092 6.96022 3.20502 8.72753L3.17008 9.26032L3.70402 9.26025C4.78558 9.26009 5.29379 9.25757 5.71491 9.19087Z",
    stroke: "url(#paint0_linear_158_1651)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_158_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7082 11.1768C15.2077 11.1768 14.8019 11.5825 14.8019 12.083C14.8019 12.5835 15.2077 12.9893 15.7082 12.9893H19.3332C19.8337 12.9893 20.2394 12.5835 20.2394 12.083C20.2394 11.5825 19.8337 11.1768 19.3332 11.1768H15.7082Z",
    fill: "#062A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 16.0101C9.166 16.0101 8.76025 16.4158 8.76025 16.9163C8.76025 17.4169 9.166 17.8226 9.6665 17.8226H19.3332C19.8337 17.8226 20.2394 17.4169 20.2394 16.9163C20.2394 16.4158 19.8337 16.0101 19.3332 16.0101H9.6665Z",
    fill: "#062A6A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_158_1651",
    x: -21.375,
    y: -22.5835,
    width: 71.75,
    height: 74.1665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_158_1651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_158_1651",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_158_1651",
    x: 5.76025,
    y: 8.17676,
    width: 27.479,
    height: 22.646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_1651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_1651",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_1651",
    x1: 3.625,
    y1: 2.4165,
    x2: 27.6678,
    y2: 24.0331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_1651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjsduration);
export default __webpack_public_path__ + "static/media/Bootcamp js duration.68bab451fdff48b61f5396f0558a84e5.svg";
export { ForwardRef as ReactComponent };